import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Product } from "../../models/product.model";

@Injectable()
export class ProductProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Product> {
    return this.http
      .get<Product>(`${this.url}/products/${id}`)
      .map(response => {
        return new Product(response);
      })
      .catch(this.handleError)
  }

  getByProductCategoryID(productCategoryID: number): Observable<Product[]> {
    return this.http
      .get<Product[]>(`${this.url}/products/product-category/${productCategoryID}`)
      .map(response => {
        return response.map((product) => new Product(product));
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Product[]> {
    return this.http
      .get<Product[]>(`${this.url}/products`)
      .map(response => {
        return response.map((product) => new Product(product));
      })
      .catch(this.handleError);
  }

  watched(id: number, animation: string): Observable<Product> {
    return this.http
      .post<Product>(`${this.url}/products/watch`, { 'product_id' : id, 'animation_name' : animation})
      .map(response => {
        return new Product(response);
      })
      .catch(this.handleError)
  }

  download(id: number, download_type: string): Observable<Product> {
    return this.http
      .post<Product>(`${this.url}/products/download`, { 'product_id' : id, 'download_type' : download_type})
      .map(response => {
        return new Product(response);
      })
      .catch(this.handleError)
  }

}



// WEBPACK FOOTER //
// ./src/providers/product/product.ts